import { Modal } from 'react-daisyui'
import { DriveContact } from '@/models/drive.ts'
import { IconX } from '@tabler/icons-react'
import ContactCard from '@/components/ContactCard.tsx'

interface ContactInfoModalProps {
  contact: DriveContact | null
  modalRef: React.RefObject<HTMLDialogElement>
}

export default function ContactInfoModal({ contact, modalRef }: ContactInfoModalProps) {
  if (!contact) return null

  return (
    <Modal ref={modalRef} responsive>
      <Modal.Header className='relative'>
        <span className='font-serif text-xl'>Kontakt</span>
        <form method='dialog'>
          <button className='btn btn-sm btn-circle btn-ghost absolute right-2 top-2'>
            <IconX size={18} />
          </button>
        </form>
      </Modal.Header>
      <Modal.Body>
        <ContactCard contact={contact} layout='vertical' />
      </Modal.Body>
    </Modal>
  )
}
